import React, { useState } from "react";
import { FiUpload } from "react-icons/fi";
import { IoMdArrowDropdown } from "react-icons/io";
import { IoChevronDown } from "react-icons/io5";
import styled from "styled-components";

const ExpesneSubmitForm = () => {
    const [amount, setAmount] = useState("");
    const [description, setDescription] = useState("");
    const [paymentType, setPaymentType] = useState("company");
    const [bankAccount, setBankAccount] = useState("");
    const [spentAt, setSpentAt] = useState("");
    const [spentOn, setSpentOn] = useState("");
    const [account, setAccount] = useState("");
    const [assignedTo, setAssignedTo] = useState("");
    const [file, setFile] = useState<File | null>(null);

    const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.files && e.target.files.length > 0) {
            setFile(e.target.files[0]);
        }
    };

    const getInitials = (name: string) => {
        return name
            .split(" ")
            .map((n) => n?.[0])
            .join("");
    };

    return (
        <div>
            <Header>
                <Title>New Expense Claims</Title>
                <ActionButtons>
                    <Button variant="outline">Save as Draft</Button>
                    <Button variant="default">Submit</Button>
                    <Button variant="primary">Approve</Button>
                </ActionButtons>
            </Header>

            <Container>
                <LeftSection>
                    <FiUpload size={60} color="#777" />
                    <UploadText>Upload an image</UploadText>
                    <UploadHint>Drag and drop here, or select your file manually</UploadHint>
                    <UploadLabel htmlFor="file-upload">Upload</UploadLabel>
                    <UploadInput id="file-upload" type="file" onChange={handleFileChange} />
                    {file && <p style={{ marginTop: "0.5rem", fontSize: "13px" }}>{file.name}</p>}
                </LeftSection>

                <RightSection>
                    <FormGroup style={{ marginBottom: "2rem" }}>
                        <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
                            <Avatar>{getInitials("Sim Mong")}</Avatar>

                            <span style={{ fontWeight: "600", color: "#333", fontSize: '1.2rem' }}>James Hudson (You)</span>
                            <IoMdArrowDropdown size={30} />

                        </div>
                    </FormGroup>

                    <FormGroup>
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                            <Label>Purchase Amount</Label>
                            <Label style={{ color: "#28a745", marginBottom: 0 }}>Itemise</Label>
                        </div>
                        <div style={{ display: "flex", alignItems: "center" }}>
                            <Select
                                style={{
                                    padding: "7px",
                                    border: "1px solid #ccc",
                                    borderRight: "none",
                                    borderRadius: "4px 0 0 4px",
                                }}
                                value={bankAccount}
                                onChange={(e) => setBankAccount(e.target.value)}
                            >
                                <option value="">USD</option>
                                <option value="axis">SG</option>
                                <option value="icici">INR</option>
                            </Select>

                            <Input
                                style={{
                                    flex: 1,
                                    padding: "8px",
                                    border: "1px solid #ccc",
                                    borderRadius: "0 4px 4px 0",
                                }}
                                placeholder="Enter amount"
                                value={amount}
                                onChange={(e) => setAmount(e.target.value)}
                            />
                        </div>


                    </FormGroup>


                    <FormGroup>
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                            <Label>Description</Label>
                            <Label style={{ color: "#28a745", marginBottom: 0 }}>{description.length}/1000</Label>
                        </div>
                        <TextArea
                            rows={4}
                            maxLength={1000}
                            placeholder="Enter description"
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                        />
                    </FormGroup>


                    <FormGroup>
                        <Label>How did you pay?</Label>
                        <div style={{ display: "flex", alignItems: 'center', gap: ".4rem" }}>
                            <RadioInput
                                type="radio"
                                id="company"
                                name="payment"
                                checked={paymentType === "company"}
                                onChange={() => setPaymentType("company")}
                            />
                            <RadioLabel htmlFor="company">Company money (non-reimbursable)</RadioLabel>
                        </div>
                        <div style={{ display: "flex", alignItems: 'center', gap: ".4rem" }}>
                            <RadioInput
                                type="radio"
                                id="personal"
                                name="payment"
                                checked={paymentType === "personal"}
                                onChange={() => setPaymentType("personal")}
                            />
                            <RadioLabel htmlFor="personal">Personal money (reimbursable)</RadioLabel>
                        </div>
                    </FormGroup>

                    <FormGroup>
                        <Label>Company Bank Account</Label>
                        <Select
                            value={bankAccount}
                            onChange={(e) => setBankAccount(e.target.value)}
                        >
                            <option value="">Select company bank account</option>
                            <option value="axis">Axis Bank - XXXX1234</option>
                            <option value="icici">ICICI Bank - XXXX5678</option>
                        </Select>
                    </FormGroup>

                    <FormGroup>
                        <div style={{ display: "flex", gap: "1rem" }}>
                            <div style={{ display: "flex", flexDirection: "column", flex: 1 }}>
                                <Label>Spent At</Label>
                                <Input
                                    placeholder="Select contact"
                                    value={spentAt}
                                    onChange={(e) => setSpentAt(e.target.value)}
                                />
                            </div>
                            <div style={{ display: "flex", flexDirection: "column", flex: 1 }}>
                                <Label>Spent On</Label>
                                <Input
                                    type="date"
                                    value={spentOn}
                                    onChange={(e) => setSpentOn(e.target.value)}
                                />
                            </div>
                        </div>
                    </FormGroup>



                    <FormGroup>
                        <Label>Account</Label>
                        <Select
                            value={bankAccount}
                            onChange={(e) => setBankAccount(e.target.value)}
                        >
                            <option value="">Select account</option>
                            <option value="axis">Axis Bank - XXXX1234</option>
                            <option value="icici">ICICI Bank - XXXX5678</option>
                        </Select>
                    </FormGroup>

                    <FormGroup>
                        <Label>Assigned To</Label>
                        <Input
                            placeholder="Enter customer name"
                            value={assignedTo}
                            onChange={(e) => setAssignedTo(e.target.value)}
                        />
                    </FormGroup>

                    <Summary>
                        <SummaryRow>
                            <div>Subtotal before GST</div>
                            <div>SGD 0.00</div>
                        </SummaryRow>
                        <SummaryRow>
                            <div>GST</div>
                            <div>0.00</div>
                        </SummaryRow>
                        <GrandTotalRow>
                            <div>Grand Total</div>
                            <div>0.00</div>
                        </GrandTotalRow>
                    </Summary>
                </RightSection>
            </Container>
        </div>
    );
};

export default ExpesneSubmitForm;

const Avatar = styled.div<{ bg?: string }>`
  background: ${({ bg }) => bg || "rgb(230, 230, 250)"};
  color: black;
  font-weight: bold;
  width: 38px;
  height: 38px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
`;

const Container = styled.div`
  display: flex;
  gap: 2rem;
  padding: 2rem;
  height: calc(100vh - 80px); 
  overflow: hidden;
`;

const LeftSection = styled.div`
  background: #f8f8f8;
  border: 1px dashed #ccc;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  text-align: center;
`;

const UploadText = styled.p`
  color: #2b2f32;
  font-weight: bold;
  margin: 0;
`;

const UploadHint = styled.p`
  color: #777;
  font-size: 14px;
  margin: 0.5rem 0;
`;

const UploadInput = styled.input`
  display: none;
`;

const UploadLabel = styled.label`
  padding: 0.4rem 1.2rem;
  border: 1px solid #28a745;
  background-color: transparent;
  color: #28a745;
  border-radius: 4px;
  cursor: pointer;
  margin-top: 1rem;

  &:hover {
    background-color: #28a745;
    color: white;
  }
`;

const RightSection = styled.div`
  flex: 1;
  overflow-y: scroll;      
  max-height: 100%;
  padding-right: 1rem;

//   /* Optional: WebKit scrollbar styling */
//   &::-webkit-scrollbar {
//     width: 8px;
//   }

//   &::-webkit-scrollbar-thumb {
//     background-color: #ccc;
//     border-radius: 4px;
//   }

//   &::-webkit-scrollbar-track {
//     background-color: #f0f0f0;
//   }
`;


const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom : 1rem;
  border-bottom: 1px solid #ccc;
`;

const Title = styled.h2`
  margin: 0;
`;

const ActionButtons = styled.div`
  display: flex;
  gap: 1rem;
`;

interface ButtonProps {
    variant?: "primary" | "outline" | "default";
}

const Button = styled.button<ButtonProps>`
  padding: 0.4rem 1rem;
  border-radius: 4px;
  border: 1px solid;
  cursor: pointer;
  font-weight: medium;

  ${({ variant }) =>
        variant === "primary"
            ? `background: #28a745; color: white; border-color: #28a745;`
            : variant === "outline"
                ? `background: transparent; color: #000; border-color: #ccc;`
                : `background: #ffffff; border-color: #28a745; color: #28a745`}
`;

const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 1rem;
`;

const Label = styled.label`
  font-size: 14px;
  margin-bottom: 0.25rem;
`;

const Input = styled.input`
  padding: 0.4rem;
  border: 1px solid #ccc;
  border-radius: 4px;
`;

const TextArea = styled.textarea`
  padding: 0.5rem;
  border: 1px solid #ccc;
  border-radius: 4px;
  resize: vertical;
`;

const Summary = styled.div`
  margin-top: 2rem;
`;

const SummaryRow = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 0.5rem;
  font-size: 14px;
`;

const GrandTotalRow = styled(SummaryRow)`
  font-weight: bold;
  font-size: 16px;
  margin-top: 1rem;
  border-top: 1px solid #ccc;
  padding-top: 1rem;
`;

const RadioLabel = styled.label`
 font-size: 14px;
`;

const RadioInput = styled.input`
  accent-color: #28a745; 
`;

const Select = styled.select`
  padding: 0.4rem;
  border: 1px solid #ccc;
  border-radius: 4px;
`;

